var exports = {
  "n": "xa15a2ab7--0ec946--tour-slide",
};

module.exports = exports;
